import {
  Modal,
  Box,
  Text,
  Group,
  Grid,
  Select,
  Textarea,
  Button,
} from "@mantine/core";
import React from "react";
import { IconFileOff, IconDeviceFloppy, IconCancel } from "@tabler/icons-react";
import type { IModalCancelarTareaVistaProps } from "../interfaces";


const ModalCancelarTareaVista: React.FunctionComponent<IModalCancelarTareaVistaProps> = ({
  abrir,
  abrirModal,
  tareaSeleccionado,
  datosCancelacion,
  alCambiarValor,
  guardarCancelacion,
  errores,
  causalesCancelacion
}) => {

  return (
    <Modal
      closeOnClickOutside={false}
      opened={abrir}
      styles={{
        header: { backgroundColor: '#0074d914' } // Rojo claro para cancelación
      }}
      onClose={() => abrirModal(false, null)}
      title={
        <Group gap={8}>
          <IconCancel size={20} color="var(--mantine-color-primary-0)" />
          <Text fw={500} fz="lg">
            Cancelar Tarea #{tareaSeleccionado.Id}
          </Text>
        </Group>
      }
      overlayProps={{
        backgroundOpacity: 0.55,
        blur: 1,
        zIndex: 100000,
      }}
      zIndex={100000}
      centered
      size={"40%"}
      radius="md"
      withCloseButton
    >
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          height: "auto",
          minHeight: "300px",
        }}>
        <Box
          p="md"
          style={{
            flex: 1,
          }}
        >
          <Grid gutter="md">
            <Grid.Col span={12}>
              <Text size="sm" c="dimmed" mb="md">
                ¿Está seguro de que desea cancelar esta tarea? Esta acción no se puede deshacer.
              </Text>
            </Grid.Col>

            <Grid.Col span={12}>
              <Select
                leftSection={<IconFileOff size={15} />}
                label="Motivo de Cierre"
                placeholder="Seleccione un motivo"
                required
                size="xs"
                clearable
                searchable
                comboboxProps={{ zIndex: 1000000 }}
                data={causalesCancelacion.map(causal => ({
                  value: causal.Id.toString(),
                  label: causal.Nombre
                }))}
                nothingFoundMessage="No se encontraron motivos"
                value={datosCancelacion.CausalCancelacionId?.toString() || ''}
                error={errores.causalCierre}
                onChange={(value) => alCambiarValor('CausalCancelacionId', Number(value) || 0)}
              />
            </Grid.Col>

            <Grid.Col span={12}>
              <Textarea
                label="Observación"
                placeholder="Ingrese una observación detallada sobre la cancelación..."
                required
                size="xs"
                maxLength={150}
                minRows={4}
                maxRows={6}
                description={`${datosCancelacion.ComentariosCancelacion.length}/150 caracteres`}
                value={datosCancelacion.ComentariosCancelacion}
                error={errores.observacion}
                inputWrapperOrder={['label', 'input', 'description', 'error']}
                onChange={(event) => alCambiarValor('ComentariosCancelacion', event.currentTarget.value)}
                styles={{
                  input: {
                    resize: 'vertical'
                  }
                }}
              />
            </Grid.Col>
          </Grid>
        </Box>

        <Box
          p="md"
          style={{
            backgroundColor: "#fff",
            borderTop: "1px solid #e9ecef",
          }}
        >
          <Group justify="flex-end" gap="sm">
            <Button
              onClick={guardarCancelacion}
              color="primary"
              variant="filled"
              size='compact-sm'
              radius="lg"
              leftSection={<IconDeviceFloppy size={15} />}
            >
              <Text fw={500} fz={11}>Confirmar Cancelación</Text>
            </Button>
          </Group>
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalCancelarTareaVista;
